export default "__VITE_ASSET__DYJsvU90__"